import Axios from 'axios'
import type { UrlObject } from 'url'

import { API_URL } from '@/utils/Consts'

const axios = Axios.create({
  baseURL: typeof window === 'undefined' ? process.env.API_INTERNAL_HOST_URL || process.env.NEXT_PUBLIC_API_HOST_URL : process.env.NEXT_PUBLIC_API_HOST_URL,
  timeout: 60000,
  xsrfCookieName: process.env.NEXT_PUBLIC_XSRF_COOKIE_NAME || 'XSRF-TOKEN',
  headers: {
    'Cache-Control': 'no-cache',
    'X-Requested-With': 'XMLHttpRequest',
    'accept': 'application/json',
    'Content-Type': 'application/json',
    'Authorization': process.env.NEXT_PUBLIC_ENVIRONMENT == 'dev' ? `Bearer ${process.env.NEXT_PUBLIC_API_TOKEN}` : '',
  },
  withCredentials: true,
})

/**
 * Globally intercept all api calls made by axios.
 *
 * @param logout from useAuth() hook
 */
// eslint-disable-next-line no-unused-vars
export const setupInterceptors = (logout: (localMutation: Boolean, redirect: UrlObject | string) => Promise<void>) => {
  axios.interceptors.response.use(
    response => {
      return response
    },

    error => {
      /**
       * Any status codes that falls outside the range of 2xx cause this function to trigger
       *    401 -- unauthorized
       *    419 -- session expired
       */

      // 1011 -- user suspended
      if (error.response?.data?.code == 1011 && error.config.url !== API_URL.login && window.location.pathname !== '/login') {
        logout(true, { pathname: '/', query: { error: 1011 } })
      }

      // Flag user-end network errors so Sentry beforeSend can filter them.
      // These are NOT frontend/backend bugs — they are caused by the user's
      // unstable connection, navigation away, or request timeout.
      if (error.isAxiosError && !error.response) {
        error._isUserNetworkError = true
      }

      return Promise.reject(error)
    }
  )
}

export default axios
